import { useMemo } from 'react';
import { useServicesContext } from '../../context';
export const useScsUrlParts = () => {
    const { getConfiguration, getEnvironmentConfig } = useServicesContext();
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const content = audiContentService === null || audiContentService === void 0 ? void 0 : audiContentService.getContent();
    const { versionsMapping, marketPath, language, market, scsBaseUrl, defaultVersion, isUsedCarMkt, apiKey, } = getScsUrlPartsFromConfiguration(getConfiguration(), getEnvironmentConfig(), content);
    return useMemo(() => ({
        versionsMapping,
        marketPath,
        language,
        market,
        scsBaseUrl,
        defaultVersion,
        isUsedCarMkt,
        apiKey,
    }), [
        defaultVersion,
        language,
        market,
        marketPath,
        scsBaseUrl,
        versionsMapping,
        isUsedCarMkt,
        apiKey,
    ]);
};
export const getScsUrlPartsFromConfiguration = (configuration, envConfig, content) => {
    var _a, _b, _c;
    let versionsMapping = null;
    if (envConfig) {
        versionsMapping = envConfig.scs.apiVersionMapping;
    }
    const defaultVersion = envConfig === null || envConfig === void 0 ? void 0 : envConfig.scs.defaultApiVersion;
    const vtpConfig = (_b = (_a = content === null || content === void 0 ? void 0 : content.fields) === null || _a === void 0 ? void 0 : _a.vtpConfiguration) === null || _b === void 0 ? void 0 : _b.fields;
    const marketPath = vtpConfig ? vtpConfig.scs_scsMarketPath : (_c = configuration === null || configuration === void 0 ? void 0 : configuration.scs) === null || _c === void 0 ? void 0 : _c.scsMarketPath;
    const [language, market] = marketPath ? marketPath.split('/') : [];
    const scsBaseUrl = envConfig === null || envConfig === void 0 ? void 0 : envConfig.scs.baseUrl;
    const apiKey = envConfig === null || envConfig === void 0 ? void 0 : envConfig.scs.apiKey;
    const isUsedCarMkt = marketPath === null || marketPath === void 0 ? void 0 : marketPath.includes('uc');
    return {
        versionsMapping,
        marketPath,
        language,
        market,
        scsBaseUrl,
        defaultVersion,
        isUsedCarMkt,
        apiKey,
    };
};
